import { render, staticRenderFns } from "./index.vue?vue&type=template&id=3da88a43&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\git仓库\\xingxingzu\\multi_merchant_web\\supplier\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3da88a43')) {
      api.createRecord('3da88a43', component.options)
    } else {
      api.reload('3da88a43', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=3da88a43&", function () {
      api.rerender('3da88a43', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/payment/index.vue"
export default component.exports